const auditMerchantAuth = {
    path: 'auditMerchantAuth',
    component: resolve => require(['@/pages/admin/riskMerchantHandle/auditMerchantAuth'], resolve)
}
export default auditMerchantAuth